// extracted by mini-css-extract-plugin
export default {"user-stores-list-container":"AccountMenu_user-stores-list-container__SFUiT","user-stores-list":"AccountMenu_user-stores-list__whkh2","list-item":"AccountMenu_list-item__YMHA1"};